module.exports = __webpack_public_path__ + "img/image10.91d6bc6a.png";